import { ConfigProvider } from "antd"
import React from "react"

import { POPUP_SCOPE_ATTR, popupContainerWithinScope } from "./popup-scope"

/**
 * The scrolling body of a calendar form, and the popup scope that goes with it.
 *
 * One component because the halves are inert apart: a scope that is not the box
 * that scrolls anchors popups to something that never moves, and a scroll box
 * with no scope leaves them on `document.body`, where nothing bounds them to the
 * modal.
 *
 * `ConfigProvider` rather than a prop per control, so a field added to either
 * form inherits this without anyone remembering to thread it through.
 */
export function CalendarFormScrollArea({
  children
}: {
  children: React.ReactNode
}) {
  return (
    <ConfigProvider getPopupContainer={popupContainerWithinScope}>
      <div
        {...{ [POPUP_SCOPE_ATTR]: "" }}
        // `relative` is load-bearing: an absolutely positioned popup resolves
        // against its nearest *positioned* ancestor, so on a static box it is
        // neither carried by the scrolling nor clipped by the overflow.
        className={"relative flex flex-col gap-6 overflow-auto px-1 py-1 flex-1"}
      >
        {children}
      </div>
    </ConfigProvider>
  )
}
